import http from '../services/http';

import {
    VALIDATE_BOOKING_ORGANISATION_ENDPOINT,
    VALIDATE_BOOKING_DELEGATE_ENDPOINT,
    VALIDATE_BOOKING_PAYMENT_ENDPOINT,
    PROCESS_BOOKING_ENDPOINT
} from '../services/endpoints';

export default (() => {

    const validateOrganisation = (organisationDetails) => {

        return http.post(VALIDATE_BOOKING_ORGANISATION_ENDPOINT, organisationDetails);
    };

    const validateDelegate = (delegateDetails) => {

        return http.post(VALIDATE_BOOKING_DELEGATE_ENDPOINT, delegateDetails);
    };

    const validatePayment = (paymentDetails) => {

        return http.post(VALIDATE_BOOKING_PAYMENT_ENDPOINT, paymentDetails);
    };

    const processBooking = (bookingValues) => {

        return http.post(PROCESS_BOOKING_ENDPOINT, bookingValues);
    };

    return {
        validateOrganisation,
        validateDelegate,
        validatePayment,
        processBooking
    };

})();


// WEBPACK FOOTER //
// ./services/payment.js